import { render } from "./PlanSummary.vue?vue&type=template&id=2708d504&scoped=true"
import script from "./PlanSummary.vue?vue&type=script&lang=js"
export * from "./PlanSummary.vue?vue&type=script&lang=js"

import "./PlanSummary.vue?vue&type=style&index=0&id=2708d504&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2708d504"]])

export default __exports__